import { Button } from '@material-tailwind/react';
import * as XLSX from 'xlsx';

const ExportToExcelCredencial = ({ data, titulo, color, className }) => {

  const exportToExcel = () => {
    let dataExcel = [];

/*
cardId	    datefld1	datefld2	datefld3	                datefld4	datefld5	    datefld6	datefld7
28679095	Región 8	MA	        STOLARCZUK EZEQUIEL JORGE	DNI    	    28.679.095  	28679095	4. Ministro Autorizado

1 nro_documento
2 `Región ${id_region}`
3 es el codigo corto del rango
4 nombre.toUpperCase()
5 DNI
6 documento en miles
7 nro_documento
8 rango

*/
    data.map(item => {
      let newData = {
        cardId:  item.nro_documento,
        datefld1: `Región ${item.id_region}`,
        datefld2: item.iniciales,
        datefld3: item.nombre.toUpperCase(),
        datefld4: 'DNI',
        datefld5:formatearMiles(item.nro_documento),
        datefld6: item.nro_documento,
        datefld7: item.rango
      }
      dataExcel.push(newData);
    })
 
    // Crear la hoja de cálculo desde un arreglo de datos
    const worksheet = XLSX.utils.json_to_sheet(dataExcel, { origin: 'A1' }); 
    
    // Ancho de columnas
    worksheet['!cols'] = [
      { wch: 15 },  
      { wch: 15 }, 
      { wch: 15 }, 
      { wch: 30 }, 
      { wch: 15 }, 
      { wch: 15 }, 
      { wch: 15 }, 
    ];

    // Crear un nuevo libro de trabajo
    const workbook = XLSX.utils.book_new();

    // Añadir la hoja al libro
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Descargar el archivo
    XLSX.writeFile(workbook, `excelcredenciales.xlsx`);
  };

  return (
    <Button 
      variant="gradient" 
      color={color || "blue-gray"}
      className={className || "flex justify-center items-center gap-3 mb-3 lg:mb-0"} 
      onClick={exportToExcel}
    >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="h-4 w-4/"
            >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
            />
        </svg>
            {titulo}
      </Button>
  );
};

export default ExportToExcelCredencial;

function formatearMiles(numero) {
    const num = Number(numero);
    
    const miles = num.toLocaleString('es-AR');

    return miles.toString();

}